import React from 'react';
import { Grid, Typography, Rating } from '@mui/material';

const HotelRating = ({ rating, isFromMap }) => {
  const parsedRating = Number.parseInt(rating, 10);
  if (parsedRating <= 1 || Number.isNaN(parsedRating)) {
    return null;
  }

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: isFromMap ? 0 : '2px',
      }}
    >
      <Typography
        sx={{
          fontSize: isFromMap ? 14 : 16,
          lineHeight: 1,
          fontWeight: 700,
          color: '#ffb400',
        }}
      >
        {parsedRating}
      </Typography>
      <Rating value={1} max={1} readOnly sx={{ fontSize: 22 }} />
    </Grid>
  );
};

export default HotelRating;
